<div class="manage-recipient">
    <np-add-beneficiary-step></np-add-beneficiary-step>
    
    <div class="col-md-10 offset-md-1">
        <div class="receipient-header">
            <strong>Add new beneficiary | </strong>Ultimate Remitter information
        </div>
    </div>
    
    <div class="col-sm-12 col-md-4 offset-md-4">
        <np-remitter-details [remitterDetailsForm]="remitterDetails" [countries]="newRecipientModel.step1.countries" [fullyStretchView]="true"></np-remitter-details>

        <div class="row mb-3">
            <div class="col-md-6">
                <button class="btn btn-block btn-lg btn-greengo-o" (click)="back()">Back</button>
            </div>
            <div class="col-md-6">
                <button class="btn btn-block btn-lg" [ngClass]="{
                        'btn-greengo': remitterDetails.valid,
                        'btn-inactive': !remitterDetails.valid
                    }" (click)="next()">
                    <ng-container *ngIf="action !== addRecipientFrom.SendPayment">Next</ng-container>
                    <ng-container *ngIf="action === addRecipientFrom.SendPayment">Send payment</ng-container>
                </button>
            </div>
        </div>
    </div>
</div>

